<template>
<div class="chapter">
<div class="inner_page">
<div style="margin-top:2em;">
<h2 class="h2v"><a id="page_xiii"></a>ACKNOWLEDGMENTS</h2>
<p class="noindent">Too many to count have brought the fire to me, always selflessly, never tiring, superabundant. The inadequacy of offering mere words in gratitude for such overflowing warmth is a burden that those who have benefited from others must bear. But gratitude is neither a currency nor a form of compensation: rather, it is an acknowledgment of the impossibility of paying back the gifts that one has received. I offer my limitless, yet forever insufficient, gratitude to John Sallis, Jerry Sallis, Robert Metcalf, Marina McCoy, Drew Hyland, Mary Troxell, and Yvonne and Robert Ewegen. I thank also Dee Mortensen and Indiana University Press for their help and support, and Emma Young for her invaluable assistance. I am grateful, too, to Joe Sachs for his excellent and timely translation of the <em>Cratylus</em>. I offer endless gratitude to Maggie, who has had to live with me during the creation of this book and will, hopefully, be living with me for the creation of many more. Finally, I offer this book to Søren, the greatest cat in the universe, who sat on it at every stage of its creation. May the finished product be as comfortable to you as were the many drafts leading up to it—and may there be hardbound books, potent catnip, and buttery croissants in kitty heaven.<a id="page_xiv"></a></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Ack.vue?50301d12